<template>
  <div>
    <!-- <v-alert v-if="activities && activities.length > 0" type="info" tile dense>Update: as of July 1, we've changed from a penalty to a bonus points system based on your social distancing. We now award 1 point per km (instead of per meter).</v-alert> -->
    <v-skeleton-loader v-if="!user || $store.getters.loading" type="table"></v-skeleton-loader>
    <v-simple-table fixed-header v-if="activities && activities.length > 0" >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">{{$t('profile.activities.sport')}}</th>
            <th class="text-left">{{$t('profile.activities.source')}}</th>
            <th class="text-left">{{$t('profile.activities.date')}}</th>
            <th class="text-left">{{$t('profile.activities.time')}}</th>
            <th class="text-left">{{$t('profile.activities.distance')}}</th>
            <th class="text-left"><v-btn text small color="accent" @click.stop="$refs.pointInfo.show()" class="pl-0">{{$t('profile.activities.points')}} <i class="far fa-question-circle"/></v-btn></th>
            <th class="text-left px-0">&nbsp;</th>
            <th class="text-left">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <router-link v-for="(item, idx) in activities" :key="'act'+idx" :to="{name: 'activity', params: {id: item.id}}" v-slot="{ href, navigate }" custom>
            <tr :href="href" @click="navigate">
              <td class="pr-0" style="width:30px;"><v-icon :title="item.type">{{$helpers.getActivityIcon(item.type)}}</v-icon></td>
              <td class="pr-0" style="width:30px;"><v-icon :title="item.prov">{{$helpers.getProviderIcon(item.prov)}}</v-icon></td>
              <td v-if="adminMode">{{ item.start | localDate('L LTS Z') }}</td>
              <td v-else>{{ item.start | moment('L LTS') }}</td>
              <td>{{ item.time_s | duration }} </td>
              <td v-if="item.type == 'STAIR_CLIMBING'">{{ item.custom }} stairs </td>
              <td v-if="item.type != 'STAIR_CLIMBING'">{{ item.dist | distance(profile.unit) }} </td>
              <td class="pr-0">
                <ActivityScoreChip v-if="item.score" :points="item.score ? item.score.total_pts : null"/>
              </td>
              <td class="px-0" style="width:32px;">
                <ActivityPenaltyScoreChip :base="item.score ? item.score.base_pts : 0" :penalty="item.score ? item.score.penalty_pts : 0" />
                <ActivityBonusScoreChip :base="item.score ? item.score.base_pts : 0" :bonus="item.score ? item.score.bonus_pts : 0" />
              </td>
              <td>
                <v-btn text small color="accent" :to="{name:'profileUpload', query: {activityId: item.id}}" :title="$t('profile.upload-photo.upload-photo')"><v-icon small class="fa fa-camera-alt" /></v-btn>
                <v-btn v-if="!adminMode" text small color="primary" :to="{name: 'activity', params: {id: item.id}}">{{$t('shared.view')}}</v-btn>
              </td>
            </tr>
          </router-link>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider  />
    <div v-if="!compact && meta && meta.has_more" class="full-width-separator text-center mt-6">
      <v-btn class="" rounded outlined @click="loadNextPage">{{$t('shared.load-more-data')}}</v-btn>
    </div>
    <v-alert type="info" tile v-if="activities && activities.length == 0">
      {{$t('profile.activities.no-activities-yet')}}
    </v-alert>
    <PointsInfoDialog ref="pointInfo"/>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { EventBus } from '@/plugins/eventbus.js';
import PointsInfoDialog from "@/components/PointsInfoDialog.vue";
import activityService from "@/services/activityService";
import ActivityScoreChip from "@/components/ActivityScoreChip";
import ActivityPenaltyScoreChip from "@/components/ActivityPenaltyScoreChip";
import ActivityBonusScoreChip from "@/components/ActivityBonusScoreChip";

export default {
  name: "ActivityGrid",
  components: {
    ActivityScoreChip,
    ActivityPenaltyScoreChip,
    ActivityBonusScoreChip,
    PointsInfoDialog,
  },
  props: {
    limit: Number,
    compact: Boolean,
    adminMode: Boolean,
    profile: Object,
    autoLoad: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activities: null,
      meta: null,
    };
  },
  async mounted() {
    await this.loadData();
    
    EventBus.$on('login-state-change', async user => {
      await this.loadData();
    });
  },
  methods: {
    async loadActivities(activities) {
      this.activities = activities;
      this.meta = {};
      console.log('Loading activities', activities);
    },
    async loadData() {
      if (this.user && this.autoLoad) {
        if (this.adminMode) {
          activityService.impersonationProfileId = this.profile.id;
        }
        const response = (await activityService.all(this.limit)).data;
        this.meta = response.meta;
        this.activities = response.data;
      }
    },
    async loadNextPage() {
        const response = (await activityService.allPaged(this.limit, this.meta.continuation_token)).data;
        this.meta = response.meta;
        this.activities = this.activities.concat(response.data);
    },
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  },

};
</script>

<style lang="scss">
  .full-width-separator {
    border-top: solid 1px rgba(0, 0, 0, 0.27);;
    .v-btn {
      margin-top: -24px !important;
      background-color: white;
    }
  }
</style>

